module.exports = __webpack_public_path__ + "img/teacher11.0b251e64.webp";